import { DropdownItem } from '../../models/dropdown-item';
import { Country } from '../../models/common-data/country';
import { State } from '../../models/common-data/state';
import { PioneerUtils } from '../../utils/pioneer-utils';
import { PayorType } from 'app/event/models/common-data/payorType';
import { Constants } from '../../../shared/constants';
import { Currency } from '../../models/common-data/currency';

export class CommonDataMapper {

    static convertCountriesToDropDownItem(countries: Country[]): DropdownItem[] {
        return countries.map(country => CommonDataMapper.convertCountryToDropDownItem(country));
    }

    static convertCurrenciesToDropDownItem(currencies: Currency[]): DropdownItem[] {
      return currencies.map(currency => CommonDataMapper.convertCurrencyToDropDownItem(currency));
    }

    static convertStatesToDropDownItem(states: State[]): DropdownItem[] {
        return states.map(state => CommonDataMapper.convertStateToDropDownItem(state));
    }

    static removeDuplicateStatesToDropDownItem(state: State): Boolean {
      return Constants.STATE_INVALID_DUPLICATED.indexOf(PioneerUtils.safeTrim(state.stateCode)) < 0;
    }

    static fixDuplicateState(state: string) {
      switch (state) {
        case Constants.STATE_QUEBEC_INVALID:
          return Constants.STATE_QUEBEC_VALID;
        case Constants.STATE_NEW_FOUNDLAND_INVALID:
          return Constants.STATE_NEW_FOUNDLAND_VALID;
        case Constants.STATE_YUKON_INVALID:
          return Constants.STATE_YUKON_VALID;
        default:
          return state;
      }
    }

    static convertCountryToDropDownItem(country: Country): DropdownItem {
      return new DropdownItem(PioneerUtils.safeTrim(country.code), PioneerUtils.safeTrim(country.longDescription));
    }

    static convertCurrencyToDropDownItem(currency: Currency): DropdownItem {
      return new DropdownItem(PioneerUtils.safeTrim(currency.code), PioneerUtils.safeTrim(currency.shortDescription));
    }

    static convertStateToDropDownItem(state: State): DropdownItem {
        return new DropdownItem(PioneerUtils.safeTrim(state.stateCode), PioneerUtils.safeTrim(state.name));
    }

    static convertPayorTypesToDropDownItem(payorTypes: PayorType[]): DropdownItem[] {
      return payorTypes.map(payorType => CommonDataMapper.convertPayorTypeToDropDownItem(payorType));
    }

    static convertPayorTypeToDropDownItem(payorType: PayorType): DropdownItem {
      return new DropdownItem(PioneerUtils.safeTrim(payorType.code), PioneerUtils.safeTrim(payorType.longDescription));
    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/common-data/common-data.mapper.ts